import React, { useState } from "react";

export default function DefaultSetting() {
  // Form state
  const [formData, setFormData] = useState({
    preRenewalRemin: "yes",
    preRenewalReminDay: "",
    notifyFrequencyRen: "",
    notifyCustomerRen: "yes",
    notifyCustomerSub: "yes",
    notifyCustomeLowBal: "yes",
    notifyCustomeCan: "yes",
  });

  // Error state
  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    // Check if all required fields are filled
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required";
      }
    });

    // Additional validation for days
    if (formData.preRenewalRemin === "yes" && !formData.preRenewalReminDay) {
      newErrors.preRenewalReminDay = "Please select number of days";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Process form data here
      console.log("Form submitted:", formData);
    } else {
      console.log("Form has errors");
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="content">
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="box-body">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item position-relative">
                      <a
                        class="nav-link active"
                        id="home-tab"
                        data-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Notification Setting
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active pt-2"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <form
                        className="form-horizontal mt-2"
                        onSubmit={handleSubmit}
                      >
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group mb-0">
                              <label className="font-weight-bold">
                                Pre-renewal Reminder
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="preRenewalRemin"
                                type="radio"
                                value="yes"
                                onChange={handleChange}
                                checked={formData.preRenewalRemin === "yes"}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="preRenewalRemin"
                                type="radio"
                                value="no"
                                onChange={handleChange}
                                checked={formData.preRenewalRemin === "no"}
                              />
                              <label className="form-check-label">No</label>
                            </div>
                            {errors.preRenewalRemin && (
                              <div className="text-danger">
                                {errors.preRenewalRemin}
                              </div>
                            )}
                          </div>

                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="font-weight-bold d-block">
                                Pre-renewal Reminder Days
                                <sup className="text-danger">*</sup>
                              </label>
                              <select
                                className="form-control"
                                name="preRenewalReminDay"
                                value={formData.preRenewalReminDay}
                                onChange={handleChange}
                                required
                              >
                                <option value="">-Select Days-</option>
                                {[...Array(30)].map((_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                                <option value="180">180</option>
                                <option value="365">365</option>
                              </select>
                              {errors.preRenewalReminDay && (
                                <div className="text-danger">
                                  {errors.preRenewalReminDay}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-3">
                            <div className="form-group">
                              <label className="font-weight-bold d-block">
                                Notification Frequency in Renewal{" "}
                                <sup className="text-danger">*</sup>
                              </label>
                              <select
                                className="form-control"
                                name="notifyFrequencyRen"
                                value={formData.notifyFrequencyRen}
                                onChange={handleChange}
                              >
                                <option value="" selected>
                                  Select Frequency
                                </option>
                                <option value="OnEveryRenewal">
                                  On Every Renewal
                                </option>
                                <option value="3Days">3 Days</option>
                                <option value="5Days">5 Days</option>
                                <option value="10Days">10 Days</option>
                                <option value="15Days">15 Days</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group mb-0">
                              <label className="font-weight-bold">
                                Notify Customer On Renewal
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomerRen"
                                type="radio"
                                value="yes"
                                onChange={handleChange}
                                checked={formData.notifyCustomerRen === "yes"}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomerRen"
                                type="radio"
                                value="no"
                                onChange={handleChange}
                                checked={formData.notifyCustomerRen === "no"}
                              />
                              <label className="form-check-label">No</label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group mb-0">
                              <label className="font-weight-bold">
                                Notify Customer On Subscription
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomerSub"
                                type="radio"
                                value="yes"
                                onChange={handleChange}
                                checked={formData.notifyCustomerSub === "yes"}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomerSub"
                                type="radio"
                                value="no"
                                onChange={handleChange}
                                checked={formData.notifyCustomerSub === "no"}
                              />
                              <label className="form-check-label">No</label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group mb-0">
                              <label className="font-weight-bold">
                                Notify Customer On Low Balance
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomeLowBal"
                                type="radio"
                                value="yes"
                                onChange={handleChange}
                                checked={formData.notifyCustomeLowBal === "yes"}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomeLowBal"
                                type="radio"
                                value="no"
                                onChange={handleChange}
                                checked={formData.notifyCustomeLowBal === "no"}
                              />
                              <label className="form-check-label">No</label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group mb-0">
                              <label className="font-weight-bold">
                                Notify Customer On Cancellation
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomeCan"
                                type="radio"
                                value="yes"
                                onChange={handleChange}
                                checked={formData.notifyCustomeCan === "yes"}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                name="notifyCustomeCan"
                                type="radio"
                                value="no"
                                onChange={handleChange}
                                checked={formData.notifyCustomeCan === "no"}
                              />
                              <label className="form-check-label">No</label>
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0">
                          <button
                            type="button"
                            className="btn btn-danger btn-raised m-0"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary btn-raised m-0"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
